import { Card, Grid } from "@mui/material";
import CustomizeAppDialog from "src/layouts/dialogs/CustomizeAppDialog/CustomizeAppDialog";

import CardHeader from "./CardHeader";
import Context from "./context";
import CustomContent from "./CustomContent";
import CustomIlustration from "./CustomIlustration";
import useCustomizeCardActionsStore from "./store";

// ----------------------------------------------------------------------

export const Customization = () => {
	const [state, actions] = useCustomizeCardActionsStore();

	return (
		<Card sx={{ maxWidth: 900 }}>
			<Context.Provider value={{ state, actions }}>
				<Grid container>
					<Grid item xs={12} sm={7}>
						<CardHeader />
						<CustomContent />
					</Grid>
					<Grid item xs={12} sm={5} justifyItems={"flex-end"}>
						<CustomIlustration />
					</Grid>
				</Grid>
				<CustomizeAppDialog />
			</Context.Provider>
		</Card>
	);
};

export default Customization;
